import { Button, Breadcrumb, BPanel, Table, Progress } from '@sketchpixy/rubix';
import { Router, Link, withRouter } from 'react-router';
import React from 'react';
import ReactDOM from 'react-dom';
import { Tracker } from 'meteor/tracker';
import Moment from 'react-moment';
import moment from 'moment';
import { Base64 } from 'meteor/base64';
import { HTTP } from 'meteor/http';
import { Meteor } from 'meteor/meteor';
import { Reactive } from '../common/Reactive.mixin.js';
import { GroupBillsPayments } from '../../collections/partners/group-bills-payments';

import { UserSchema } from '../../collections/users/users';
import MgfTableComponent from '../common/mgfTable';
import { GroupBillModal } from './components/GroupBillModal';

import { GroupBills } from '../../collections/partners/group-bills';

@withRouter
@Reactive({
	subscriptions: ["group-bills"],
})
export default class GroupBillViewPage extends React.Component {
	constructor(props) {
		super(props);

		console.log('props', GroupBills.find({_id: this.props.params.id}).fetch());


    props.ready.then(() => {
      Tracker.autorun(() => {
        this.setState({
          'bill': GroupBills.find({_id: this.props.params.id}).fetch()[0],
          'payments': GroupBillsPayments.find({bill: this.props.params.id}).fetch(),
        });
      });
    });
	}

	addPayment() {

		let payment = {
			'type': ReactDOM.findDOMNode(this.refs.type).value.trim(),
			'montant': ReactDOM.findDOMNode(this.refs.montant).value.trim(),
			'informations': ReactDOM.findDOMNode(this.refs.informations).value.trim(),
			'bill': this.state.bill._id
		};

		Meteor.call('groupbills.payments.insert', payment, (function (err, _id) {
			if (err) {
				Messenger().post({
					message: "Erreur, " + err,
					type: "error"
				});
				return;
			}

			Messenger().post({
				message: "Le paiement a été enregistré.",
				type: "success"
			});
		}));

	}

	removePayment(event) {

		if(confirm('Êtes-vous sûr de vouloir supprimer ce paiement ?')) {

			let that = this;
			Meteor.call('groupbills.payments.remove', event.target.value, (function (err, _id) {
				if (err) {
					Messenger().post({
						message: "Erreur..." + err,
						type: "error"
					});
					return;
				}

				Messenger().post({
					message: "Le paiement a été supprimé.",
					type: "success"
				});
			}));

		}
	}




	render() {

		if(!this.props.isReady && !this.state.bill) {
			return (
				<Progress active value={100} />
			);
		}

		return (
    <div>
      <BPanel header="Réservations associées">
        <Table striped bordered condensed hover responsive className="text-center">
          <thead>
            <tr>
              <th>Billet</th>
              <th>Nom/Prénom</th>
              <th>Date</th>
              <th>Montant</th>
            </tr>
          </thead>
          <tbody>
            {this.state.bill.getReservations().map((reservation) => (
              <tr>
                <td>{reservation.id_billet}</td>
                <td>{reservation.searchName}</td>
                <td><Moment format="DD/MM/YYYY à kk:mm">{reservation.createdAt}</Moment></td>
                <td>{reservation.getPrice()}€</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </BPanel>

      <BPanel header="Etat de la facturation">

      <Table striped bordered responsive>
        <thead>
          <tr>
            <td>
              {this.state.bill.getSolde() > 0 &&
                <Button block bsStyle="danger">{this.state.bill.getSolde()} € restant</Button>
              }
              {this.state.bill.getSolde() <= 0 &&
                <Button block bsStyle="success">{this.state.bill.getSolde()} € restant</Button>
              }
            </td>
            <td>
              <FormControl componentClass="select" type="select" ref="type">
                  <option value="Especes">Especes</option>
                  <option value="CB internet">CB internet</option>
                  <option value="CB">CB</option>
                  <option value="Chèque">Chèque</option>
                  <option value="Virement">Virement</option>
                  <option value="Autre">Autre</option>
              </FormControl>
            </td>
            <td>
              <FormControl placeholder="Montant" type="text" ref="montant"/>
            </td>
            <td>
              <FormControl placeholder="Informations" type="text" ref="informations"/>
            </td>
            <td>
              <Button bsStyle="primary" onClick={this.addPayment.bind(this)}>Ajouter</Button>
            </td>
          </tr>
          </thead>
        </Table>
        {this.state.payments && (this.state.payments.length > 0) &&
          <Table striped bordered responsive>
            <thead>
              <tr>
                <td>Date</td>
                <td>Type</td>
                <td>Montant</td>
                <td>Informations</td>
                <td>-</td>
              </tr>
            </thead>
            <tbody>
              {this.state.payments.map((payment) => (
                <tr>
                  <td><Moment format="DD/MM/YYYY à kk:mm">{payment.createdAt}</Moment></td>
                  <td>{payment.type}</td>
                  <td>{payment.montant}€</td>
                  <td>{payment.informations}</td>
                  <td><center><Button bsStyle="danger" onClick={this.removePayment.bind(this)} value={payment._id}>X</Button></center></td>
                </tr>
              ))}
            </tbody>
          </Table>
      }

      {!this.state.payments &&
        <Progress active value={100} />
      }

      {this.state.payments && this.state.payments.length == 0 &&
        <Well>Il n'y a pas encore de paiement</Well>
      }


      </BPanel>


      <Button lg bsStyle='success' block id={this.state.bill._id} onClick={this.download.bind(this)}>Télécharger la facture</Button>

    </div>
		);
	}
}

GroupBillViewPage.contextTypes = {
	router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/partners/GroupBillView.page.js
 **/